/* eslint-disable custom-rules/modal-and-drawer-requires-title */
import { useMediaQuery } from '@uhg-abyss/web/hooks/useMediaQuery';
import { Drawer } from '@uhg-abyss/web/ui/Drawer';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Popover } from '@uhg-abyss/web/ui/Popover';
import { Text } from '@uhg-abyss/web/ui/Text';
import find from 'lodash/find';
import React, { useState } from 'react';

import { useLagoon } from '../../hooks/useLagoon';
import { ConstantsLagoon } from '../ConstantsLagoon';
import { phoneOnly } from '../ConstantsStyles';
import {
  distanceInfoIcon,
  distancePopover,
  drawerStyle,
} from '../RadioGroup/DistanceInfoIcon.styled';
import { boardCertifiedInfoIconText } from './BoardCertifiedInfoIcon.styled';

export const BoardCertifiedInfoIcon = () => {
  const [isOpen, setIsOpen] = useState(false);
  const mobileScreen = useMediaQuery(phoneOnly);
  const uiMessaging = useLagoon('ui-messaging')();
  const boardCertifiedInfoIconContent = find(uiMessaging, {
    key: ConstantsLagoon.CONTENT_FILTERS.BOARD_CERTIFIED_INFO_ICON,
  });
  const boardCertifiedInfoText = find(uiMessaging, {
    key: ConstantsLagoon.CONTENT_FILTERS.BOARD_CERTIFIED_INFO_TEXT,
  });
  const content = () => (
    <Flex
      css={{
        'abyss-flex-root': {
          padding: '16px 0px 0px 0px',
        },
      }}
      data-testid="board-certified-info-icon-popover"
      onClick={() => setIsOpen(true)}
    >
      <IconSymbol
        css={distanceInfoIcon}
        icon="info"
        size={24}
        variant="outlined"
      />
      <Text
        css={boardCertifiedInfoIconText}
        data-testid="board-certified-info-text"
      >
        {boardCertifiedInfoText?.title}
      </Text>
    </Flex>
  );

  return (
    <React.Fragment>
      {!mobileScreen ? (
        <Popover
          content={boardCertifiedInfoIconContent?.message}
          css={distancePopover}
          data-testid="board-certified-info-icon-popover"
          onOpenChange={() => {
            setIsOpen(!isOpen);
          }}
          open={isOpen}
          title={boardCertifiedInfoIconContent?.title}
          width={220}
        >
          {content()}
        </Popover>
      ) : (
        <React.Fragment>
          {content()}
          <Drawer
            css={drawerStyle}
            data-auto-testid="board-certified-info-icon-popover"
            data-testid="board-certified-info-icon-popover"
            header={boardCertifiedInfoIconContent?.title}
            isOpen={isOpen}
            onClose={() => setIsOpen(false)}
            position="right"
          >
            <div>{boardCertifiedInfoIconContent?.message}</div>
          </Drawer>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
